// api-endpoints.enum.ts
export enum ApiEndpoints {
  // Masters
  Title = 'mst_title',
  Gender = 'mst_gender',
  MaritalStatus = 'mst_maritalstatus',
  Nationality = 'mst_nationality',
  Language = 'mst_language',
  Religion = 'mst_religion',
  Caste = 'mst-casts',
  Country = 'mst_country',
  State = 'mst_state',
  District = 'mst_district',
  Department = 'mst_department',
  SubDepartment = 'mst_subdepartmentmaster',
  Tariff = 'mst_tariff',
  Doctor = 'mst_doctor',
  Relation = 'mst_relation',
  BloodGroup = 'mst_bloodgroup',
  CorporateCompany = 'mst_corporatecompany',
  DayList = 'enum_daymaster',
  Route = `mst_route`,
  Frequency = 'mst_dosefrequencymaster',


  // Special / other
  MlcTypes = 'mlctypes',
  EmergencyTypes = 'emergencytypes',
  PatientCategory = 'patient_category',
  TeleConsultationDoctors = 'mst_doctor/getTeleConsultationDoctor',
  TeleConsultationDepartments = 'mst_department/getDepartmentsForTeleConsultation',
  PincodeSearch = 'mst-areamasters/findByPincode',

  // save records
  Doctor_Slots = 'doctor-schedule/createDoctorSlotInfo'
}
